"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ramda = require("ramda");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _gift = require("../../store/gift/gift.selector");

var _gift2 = require("../../store/gift/gift.actions");

var _GiftVideoMessageForm = _interopRequireDefault(require("../../components/GiftVideoMessageForm/GiftVideoMessageForm"));

var _useEmailPreview = require("../../hooks/useEmailPreview");

var postcardActions = _interopRequireWildcard(require("../../store/gift/postcard/message/message.actions"));

var _useGiftContext2 = require("../../hooks/useGiftContext");

var _useTrackGiftingFlow = require("../../hooks/useTrackGiftingFlow");

var _invitationType = require("../../store/gift/invitationType");

var _GiftPreview = _interopRequireDefault(require("../../components/GiftPreview/GiftPreview"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    buttonIcon: {
      marginRight: spacing(1),
      color: 'inherit'
    },
    disabled: {
      opacity: 0.5,
      pointerEvents: 'none'
    },
    previewButton: {
      padding: 0,
      display: 'block',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  };
});

var VideoLandingPage = function VideoLandingPage() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var classes = useStyles();

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      sidebarMode = _useGiftContext.sidebarMode;

  var emailPreviewUrl = (0, _useEmailPreview.useEmailPreview)();
  var trackLandingPreview = (0, _useTrackGiftingFlow.useTrackGiftingFlowLandingPreviewClicked)();
  var trackMessagePreview = (0, _useTrackGiftingFlow.useTrackGiftingFlowMessagePreviewClicked)();
  var emailProviderId = (0, _reactRedux.useSelector)(_gift.getGiftEmailProviderId);
  var giftRecipientLandingPage = (0, _reactRedux.useSelector)(_gift.getGiftLandingPage);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var giftVideo = (0, _reactRedux.useSelector)(_gift.getGiftVideo);
  var isLoading = (0, _reactRedux.useSelector)(_gift.getGiftIsLoading);
  var errors = (0, _reactRedux.useSelector)(_gift.getGiftErrors);
  var isAlyceGiftCard = (0, _reactRedux.useSelector)(_gift.isAlyceGiftCardSelector);
  var isLinkInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedLinkInvitationType);
  var videoType = (0, _ramda.propOr)(_ui.VIDEO_TYPE_DISABLED, 'video_type', giftVideo);
  var videoMessage = (0, _ramda.propOr)('', 'embed_video', giftVideo);
  var vidyardImage = (0, _ramda.propOr)('', 'vidyard_image', giftVideo);
  var vidyardVideo = (0, _ramda.propOr)('', 'vidyard_video', giftVideo);
  var previewLandingPageHandler = (0, _react.useCallback)(function () {
    trackLandingPreview(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.VIDEO_LANDING_PAGE);
    window.open(giftRecipientLandingPage, '_blank');
  }, [trackLandingPreview, giftRecipientLandingPage]);
  var previewMessageHandler = (0, _react.useCallback)(function () {
    trackMessagePreview(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.VIDEO_LANDING_PAGE);

    if (sidebarMode) {
      window.open(emailPreviewUrl, '_blank');
    } else {
      dispatch(postcardActions.openCustomPreview({
        isVisible: true,
        emailProviderId,
        giftId
      }));
    }
  }, [trackMessagePreview, sidebarMode, emailPreviewUrl, dispatch, emailProviderId, giftId]);
  var handleSetVideoMessage = (0, _react.useCallback)(function (payload) {
    dispatch((0, _gift2.giftSetVideoMessage)({
      giftId,
      isReady: payload.isReady,
      type: payload.typeValue,
      videoUrl: payload.videoMessageValue,
      vidyardImage: payload.vidyardImageValue,
      vidyardVideo: payload.vidyardVideoValue
    }));
  }, [dispatch, giftId]);
  var handleNextStep = (0, _react.useCallback)(function (payload) {
    trackEvent("Gifting flow \u2014 Video step \u2014 clicked set video link and continue", _objectSpread(_objectSpread({}, payload), {}, {
      gift_id: giftId
    }));
    handleSetVideoMessage(_objectSpread(_objectSpread({}, payload), {}, {
      isReady: true
    }));
  }, [handleSetVideoMessage, trackEvent, giftId]);
  var handleUpdatePreviewVideo = (0, _react.useCallback)(function (payload) {
    handleSetVideoMessage(_objectSpread(_objectSpread({}, payload), {}, {
      isReady: false
    }));
  }, [handleSetVideoMessage]);
  var handleUpdateErrors = (0, _react.useCallback)(function (saveErrors) {
    dispatch((0, _gift2.saveGiftVideoMessageCleanError)(saveErrors));
  }, [dispatch]);
  var handleChangeVideoType = (0, _react.useCallback)(function (payload) {
    var shouldUpdatePreview = payload.typeValue === _ui.VIDEO_TYPE_VIDYARD && !(0, _ramda.isEmpty)(payload.vidyardVideoValue) || payload.typeValue === _ui.VIDEO_TYPE_EMBED || payload.typeValue === _ui.VIDEO_TYPE_DISABLED;

    if (shouldUpdatePreview) {
      handleUpdatePreviewVideo(payload);
    }

    dispatch((0, _gift2.saveGiftVideoMessageCleanError)({}));
  }, [dispatch, handleUpdatePreviewVideo]);

  var _useVideoIntegration = (0, _ui.useVideoIntegration)({
    type: videoType,
    vidyardVideo,
    vidyardImage,
    videoMessage,
    isLoading,
    errors: errors || {},
    onSave: handleNextStep,
    onUpdateErrors: handleUpdateErrors,
    onChangeType: handleChangeVideoType,
    onAfterVideoMessageChange: handleUpdatePreviewVideo,
    onAfterVidyardVideoSelect: handleUpdatePreviewVideo
  }),
      localType = _useVideoIntegration.videoType,
      localVideoMessage = _useVideoIntegration.videoMessage,
      localVidyardImage = _useVideoIntegration.vidyardImage,
      localVidyardVideo = _useVideoIntegration.vidyardVideo,
      isSaveDisable = _useVideoIntegration.isSaveDisable,
      handleVideoEnabled = _useVideoIntegration.handleVideoEnabled,
      handleVidyardSelect = _useVideoIntegration.handleVidyardSelect,
      handleVidyardRemove = _useVideoIntegration.handleVidyardRemove,
      handleSetLocalVideoMessage = _useVideoIntegration.handleSetLocalVideoMessage,
      handleSave = _useVideoIntegration.handleSave;

  var useVideo = localType !== _ui.VIDEO_TYPE_DISABLED;
  var isVideoSet = localType === _ui.VIDEO_TYPE_EMBED && videoMessage || localType === _ui.VIDEO_TYPE_VIDYARD && vidyardVideo;
  var isValid = (0, _ramda.isEmpty)(errors) || (0, _ramda.isNil)(errors);
  var canShowPreview = useVideo && isVideoSet || !useVideo;
  var isLandingPreviewEnabled = giftRecipientLandingPage && !isLoading && isValid && canShowPreview;
  var isEmailPreviewEnabled = !isLoading && isValid && canShowPreview;
  var isLandingPreviewVisible = !isAlyceGiftCard;
  var isEmailPreviewVisible = !isAlyceGiftCard && !isLinkInvitationType;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "H4-Chambray",
    pl: 4,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Dark-Bold"
  }, "Add a video")), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "Adding a video will replace your message on landing pages and will add a thumbnail to your emails.")), /*#__PURE__*/_react.default.createElement(_material.Divider, null), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2
  }, /*#__PURE__*/_react.default.createElement(_GiftVideoMessageForm.default, {
    giftId: giftId,
    type: localType,
    videoMessage: localVideoMessage,
    vidyardImage: localVidyardImage,
    vidyardVideo: localVidyardVideo,
    errors: errors || {},
    onVideoEnabled: handleVideoEnabled,
    onSetLocalVideoMessage: handleSetLocalVideoMessage,
    onVidyardSelect: handleVidyardSelect,
    onVidyardRemove: handleVidyardRemove
  }), /*#__PURE__*/_react.default.createElement(_material.Divider, null), /*#__PURE__*/_react.default.createElement(_GiftPreview.default, {
    mt: 3,
    mb: 4,
    emailAvailable: isEmailPreviewVisible,
    landingAvailable: isLandingPreviewVisible,
    onLandingPreview: previewLandingPageHandler,
    onEmailPreview: previewMessageHandler,
    emailDisabled: !isEmailPreviewEnabled,
    landingDisabled: !isLandingPreviewEnabled
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "secondary",
    disabled: isSaveDisable,
    onClick: (0, _react.useCallback)(function () {
      return handleSave();
    }, [handleSave])
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: useVideo ? 'plus' : 'arrow-right',
    color: "primary",
    className: classes.buttonIcon
  }), useVideo ? 'Set video and continue' : 'Go next without video'))));
};

var _default = VideoLandingPage;
exports.default = _default;